"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearCreatureDefinitions = exports.loadCreatureCatalog = exports.getCreatureImageUrl = exports.getCreatureLookup = exports.getCreatureDefinitionById = exports.getAvailableCreatureIds = exports.setCreatureDefinitions = void 0;
const registry = new Map();
const setEntries = (entries) => {
    for (const e of entries) {
        registry.set(e.definition.id, {
            definition: e.definition,
            ownerPluginId: e.ownerPluginId,
        });
    }
};
const setCreatureDefinitions = (entries) => {
    registry.clear();
    setEntries(entries);
};
exports.setCreatureDefinitions = setCreatureDefinitions;
const getAvailableCreatureIds = () => [...registry.keys()];
exports.getAvailableCreatureIds = getAvailableCreatureIds;
const getCreatureDefinitionById = (id) => { var _a; return (_a = registry.get(id)) === null || _a === void 0 ? void 0 : _a.definition; };
exports.getCreatureDefinitionById = getCreatureDefinitionById;
const getCreatureLookup = () => ({
    get: (id) => { var _a; return (_a = registry.get(id)) === null || _a === void 0 ? void 0 : _a.definition; },
    has: (id) => registry.has(id),
});
exports.getCreatureLookup = getCreatureLookup;
const getCreatureImageUrl = (id, facing) => {
    const entry = registry.get(id);
    if (!entry) {
        return null;
    }
    return `/plugins/${entry.ownerPluginId}/images/${facing}/${id}.png`;
};
exports.getCreatureImageUrl = getCreatureImageUrl;
const loadCreatureCatalog = (url) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const res = yield fetch(url, { cache: "no-cache" });
        if (!res.ok) {
            return;
        }
        const entries = (yield res.json());
        setEntries(entries);
    }
    catch (_a) {
        // No catalog (or a malformed one) just means no pre-game art - the full set still arrives upon game connection.
    }
});
exports.loadCreatureCatalog = loadCreatureCatalog;
const clearCreatureDefinitions = () => {
    registry.clear();
};
exports.clearCreatureDefinitions = clearCreatureDefinitions;
